<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>
            <v-col cols="12" lg="6">
                <alarm-colors :alarmColors="$props.alarmSettings.alarmColors"></alarm-colors>
            </v-col>

            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Alarm Snackbar
                        <v-icon class="setting-scope-icon">mdi-account</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-row>
                            <v-col cols="12">
                                <h3>Snackbar Enabled</h3>
                                <v-switch v-model="$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled" label="Off/On" color="#c42111" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span :class="{disabled: !$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled}">Critical Alarms</span>
                                <v-switch v-model="$props.alarmSettings.alarmSnackbar.alarmSnackbarCriticalEnabled" label="Off/On" color="#c42111" :disabled="!$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span :class="{disabled: !$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled}">Major Alarms</span>
                                <v-switch v-model="$props.alarmSettings.alarmSnackbar.alarmSnackbarMajorEnabled" label="Off/On" color="#c42111" :disabled="!$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span :class="{disabled: !$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled}">Minor Alarms</span>
                                <v-switch v-model="$props.alarmSettings.alarmSnackbar.alarmSnackbarMinorEnabled" label="Off/On" color="#c42111" :disabled="!$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled" />
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <span :class="{disabled: !$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled}">Observational Alarms</span>
                                <v-switch v-model="$props.alarmSettings.alarmSnackbar.alarmSnackbarObservationalEnabled" label="Off/On" color="#c42111" :disabled="!$props.alarmSettings.alarmSnackbar.alarmSnackbarEnabled" />
                            </v-col>

                            <v-col cols="12">
                                <v-text-field label="Snackbar Timeout (Seconds)" hint="Enter '0' for infinite timeout." type="number" min="0" persistent-hint v-model="timeout" color="#c42111"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-col cols="12" lg="12" class="px-0">
                    <emails :settings="$props.alarmSettings" templateType="alarm_email" />
                </v-col>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>
import AlarmColors from "@/components/Settings/AlarmColors";
import Emails from "@/components/Settings/Emails";
export default {
    name: 'Alarms',
    props: ['alarmSettings'],
    components: {
        AlarmColors,
        Emails
    },
    data: () => ({

    }),

    computed: {
        timeout: {
            get: function() {
                return (this.$props.alarmSettings.alarmSnackbar.alarmSnackbarTimeout / 1000);
            },
            set: function(value) {
                this.$props.alarmSettings.alarmSnackbar.alarmSnackbarTimeout = Math.round(value * 1000);
            }
        }
    },

    methods: {
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 224px); */
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        /* max-height: calc(100vh - 310px); */
        max-height: calc(100vh - 270px);
        position: relative;
    }

    .card-body .disabled {
        color: rgba(255, 255, 255, 0.5);
    }

</style>
